<template>
    <div class="main-container page-container">
        <div class="tab-box">
            <div
                class="tab-item"
                v-for="(item, index) in tabList"
                :key="index"
                :class="{ active: item.components == tab }"
                @click="handClickTabs(item.components)"
            >
                <a>{{ item.label }}</a>
            </div>
        </div>

        <component :is="tab"></component>
    </div>
</template>

<script>
import organization from './components/organization';
import team from './components/team';
// import channel from './components/channel';
import personal from './components/personal';

export default {
    components: {
        organization,
        team,
        // channel,
        personal
    },
    data() {
        return {
            tab: 'organization',
            tabList: []
        };
    },

    created() {
        let orgType = JSON.parse(localStorage.userInfo).orgType;
        // 市级机构和区级机构登录
        if(orgType == 3 || orgType == 4) {
            this.tabList = [                
                {
                    label: '机构',
                    components: 'organization'
                },
                {
                    label: '团队',
                    components: 'team'
                },
                {
                    label: '个人',
                    components: 'personal'
                }
            ]
        }else{
            this.tabList = [       
                {
                    label: '机构',
                    components: 'organization'
                },
                {
                    label: '团队',
                    components: 'team'
                },
                // {
                //     label: '渠道',
                //     components: 'channel'
                // },
                {
                    label: '个人',
                    components: 'personal'
                }
            ]
        }
    },

    methods: {
        handClickTabs(name) {
            this.tab = name;
        }
    }
};
</script>
<style lang="scss" scoped>
.page-container {
    position: relative;
    margin-bottom: 10px;
    .tab-box {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 20px;
        .tab-item {
            width: 68px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 40px;
            padding-bottom: 8px;
            a {
                color: #515a61;
                font-size: 14px;
            }

            &.active {
                border-bottom: 2px solid #236dff;

                a {
                    color: #236dff;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
